import type { Theme } from "@mui/material/styles";
import type { RaRecord } from "react-admin";
import { eventNeedsSadaratAllocation } from "@/utils/event-needs-sadarat-allocation";

/** Visual cue when a majlis has no sadarat linked (calendar + list). */
export function missingSadaratBorderLeft(theme: Theme): string {
  return `10px solid ${theme.palette.error.main}`;
}

/** Red-edge highlight when any required gender slot is missing. */
export function shouldFlagMissingSadarat(row: RaRecord | null | undefined): boolean {
  if (!row) return false;
  return eventNeedsSadaratAllocation({
    needSadaratMale: row.needSadaratMale as boolean | null | undefined,
    needSadaratFemale: row.needSadaratFemale as boolean | null | undefined,
    sadaratMaleId:
      (row.sadaratMaleId as string | null | undefined) ??
      (row.sadaratMale as { id?: string } | null | undefined)?.id ??
      null,
    sadaratFemaleId:
      (row.sadaratFemaleId as string | null | undefined) ??
      (row.sadaratFemale as { id?: string } | null | undefined)?.id ??
      null,
    needSadarat: row.needSadarat as boolean | null | undefined,
    sadaratId:
      (row.sadaratId as string | null | undefined) ??
      (row.sadarat as { id?: string } | null | undefined)?.id ??
      null,
    sadaratName: (row.sadarat as { name?: string } | null | undefined)?.name ?? null,
  });
}
